import "./style/Loader.css";

const Loader = () => {
  return (
    <div className="page-loader">
      <div className="loader-wrapper">
        <div className="spinner"></div>
        <img
          className="loader-image"
          src={`${process.env.REACT_APP_PUBLIC_URL}assets/media/logos/logo.png`}
          alt="loader-icon"
        />
      </div>
    </div>
  );
};

export default Loader;
